<div #mapContent class="map-container"></div>
